<template>
	<div class="page">
		<div class="logo">
			<div class="flex-1">
				<img class="logo-img" src="../../static/moblieHome/logo.png" alt="" />
			</div>
			<div class="red blod f14">
				<img class="phone-icon" src="../../static/moblieHome/phone.png" alt="" />0551-6287-6666
			</div>
		</div>
		<img class="banner" src="../../static/moblieHome/banner.png" alt="" />
		<img class="img-100" src="../../static/moblieHome/img1.png" alt="" />
		<img class="img-90 mt-20" src="../../static/moblieHome/img2.png" alt="" />
		<img class="img-90 mt-20" src="../../static/moblieHome/img3.png" alt="" />
		<img class="img-100 mt-20" src="../../static/moblieHome/img4.png" alt="" />
		<img class="img-100 mt-20" src="../../static/moblieHome/img5.png" alt="" />
		<img class="img-90 mt-20" src="../../static/moblieHome/img6.png" alt="" />
		<div class="code">
			<div class="phone">
				<div class="left">
					<span class="name">联系电话：0551-6287-6666</span> <br />
					<span class="c-9">营业执照注册地址</span> <br />
					<span class="c-9">合肥市包河区芜湖路347号城市华庭15-103号</span> <br />
				</div>
				<div class="right">
					<img src="../../static/moblieHome/QR.png" alt="" />
				</div>
			</div>
			<div class="record">
				<a style="color: #999;font-size: 12px;" href="https://beian.miit.gov.cn/" target="_blank">Copyright © 2025.皖ICP备2022006755号 联丰典当</a >
			</div>
		</div>
		<div class="footer-mobile">
			<div @click="sidebarActive = true" class="btn1 flex"><img src="../../static/moblieHome/form-icon.png" alt="" />立即申请</div>
			<a href="tel:0551-6287-6666" class="btn2 flex c-fff"><img src="../../static/moblieHome/form-tel.png" alt="" />电话咨询</a>
		</div>
		<!-- 借款申请 -->
		<div v-if="sidebarActive" class="form" @touchmove.stop.prevent="toMoveHandle">
			<div class="mask" :class="sidebarActive ? 'show' : 'hide'" @click.stop="closeMask()"></div>
			<div class="moblie-loan" :class="{ 'active': sidebarActive }">
				<div class="title">借款申请</div>
				<div class="red f14">BORROWING APPLICATION</div>
				<div class="form-ipt">
					<div class="user-ipt">
						<img class="user-icon" src="../../static/moblieHome/user-name.png" alt="" />
						<input class="ipt" v-model="userName" type="text" placeholder="请输入姓名"/>
					</div>
					<div class="user-ipt">
						<img class="user-icon" src="../../static/moblieHome/user-phone.png" alt="" />
						<input class="ipt" v-model="userPhone" type="text" placeholder="请输入手机号"/>
					</div>
				</div>
				<div class="submit-btn" @click="doSubmit()">立即申请</div>
			</div>
		</div>
		<!-- 申请成功 -->
		<div v-if="show" class="form1" @touchmove.stop.prevent="toMoveHandle">
			<div class="mask" :class="show ? 'show' : 'hide'" @click.stop="closeMask1()"></div>
			<div class="moblie-loan1" :class="{ 'active': show }">
				<img class="success-icon" src="../../static/moblieHome/succss.png" alt="" />
				<div class="tit">提交成功</div>
				<div class="red blod">工作人员将在30分钟内联系您～</div>
				<div class="submit-btn" @click="show = false">我知道了</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data () {
			return {
				userName: '',
				userPhone: '',
				sidebarActive: false,
				show: false,
			}
		},
		methods: {
			doSubmit() {
				if (this.userName == '') {
					this.$message.error('请输入姓名');
					return false
				}
				if (this.userPhone == '') {
					this.$message.error('请输入手机号');
					return false
				}
				
				let res = this.util.request({
					url: `/sy/getLfWebsite/submitFrom`,
					method: 'POST',
					data: {
						isCode: 0,
						userName: this.userName,
						userPhone: this.userPhone,
						clueType: 0,
					},
				}).then(res => {
					if (res.status === 200) {
						this.sidebarActive = false
						this.show = true
					}
				}).catch(error => {
					this.$message.error(error);
				});
			},
			toMoveHandle() {},
			closeMask() {
				if (this.sidebarActive) {
					this.sidebarActive = false
				}
			},
			closeMask1() {
				if (this.show) {
					this.show = false
				}
			},
		}
	}
</script>

<style scoped>
	.page {
		/* text-align: center; */
		background: #F8F8F8;
	}
	.logo {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		z-index: 10;
		height: 4.0625rem;
		line-height: 4.0625rem;
		background: #FFFFFF;
		padding: 0 0.9375rem;
		text-align: left;
		display: flex;
		align-items: center;
		.flex-1 {
			flex: 1;
		}
		.logo-img {
			width: 6.6875rem;
			height: 1.875rem;
			vertical-align: middle;
		}
		.phone-icon {
			width: 14px;
			height: 14px;
			vertical-align: middle;
			margin-right: 5px;
		}
	}
	.banner {
		max-width:100%;
		display: block; /* 防止底部出现间隙 */
		pointer-events: none;
		user-select: none; /* 禁止选择文本 */
	}
	.img-100 {
		max-width: 100%; /* 图片最大宽度为容器宽度 */
		height: auto;    /* 保持图片原始宽高比 */
		display: block; /* 防止底部出现间隙 */
		margin: 0 auto;
	}
	.img-90 {
		max-width: 96%; /* 图片最大宽度为容器宽度 */
		height: auto;    /* 保持图片原始宽高比 */
		display: block; /* 防止底部出现间隙 */
		margin: 0 auto;
	}
	.footer-mobile {
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 9;
		display: flex;
		align-items: center;
		height: 44px;
		line-height: 44px;
		font-weight: 500;
		font-size: 16px;
		color: #FFFFFF;
		.btn1 {
			width: 50%;
			background: #CF2427;
		}
		.btn2 {
			width: 50%;
			background: #E59F3A;
		}
		.flex {
			display: flex;
			align-items: center;
			justify-content: center;
		}
		img {
			width: 18px;
			height: 18px;
			margin-right: 5px;
		}
	}
	.code {
		background: #333;
		padding: 16px 12px 60px;
		margin-top: 20px;
	}
	.phone {
		display: flex;
		align-items: center;
		text-align: left;
		padding-bottom: 5px;
		border-bottom: 1px solid #686868;
		.left {
			flex: 1;
			font-weight: normal;
			.name {
				font-size: 14px;
				color: #FFFFFF;
			}
			.c-9 {
				font-size: 12px;
				color: #999999;
			}
		}
		.right {
			img {
				width: 80px;
				height: 80px;
			}
		}
	}
	.record {
		text-align: left;
		margin-top: 12px;
	}
	.mt-20 {
		margin-top: 20px;
	}
	.form {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		z-index: 10;
		text-align: left;
		.hide {
			display: none;
		}
		.show {
			display: block;
		}
		.mask {
			background: rgba(0, 0, 0, .5);
			width: 100%;
			height: 100vh;
		}
		.moblie-loan {
			padding: 30px;
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%,-50%);
			width: 294px;
			background: #FFFFFF;
			border-radius: 8px;
			.title {
				font-weight: 600;
				font-size: 20px;
				color: #333333;
			}
			.form-ipt {
				margin-top: 30px;
			}
			.user-ipt {
				height: 44px;
				line-height: 44px;
				background: #F8F8F8;
				border-radius: 22px;
				border: 1px solid #E2E2E2;
				display: flex;
				align-items: center;
				padding-left: 10px;
				padding-right: 10px;
				margin-bottom: 15px;
			}
			.ipt {
				flex: 1;
			}
			.user-icon{
				width: 22px;
				height: 22px;
				margin-right: 10px;
			}
			.submit-btn {
				height: 44px;
				line-height: 44px;
				background: #CF2427;
				border-radius: 22px;
				font-weight: 600;
				font-size: 16px;
				color: #FFFFFF;
				text-align: center;
				margin-top: 30px;
			}
		}
	}
	.form1 {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		z-index: 10;
		text-align: center;
		.hide {
			display: none;
		}
		.show {
			display: block;
		}
		.mask {
			background: rgba(0, 0, 0, .5);
			width: 100%;
			height: 100vh;
		}
		.moblie-loan1 {
			padding: 30px;
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%,-50%);
			width: 294px;
			background: #FFFFFF;
			border-radius: 8px;
		}
		.tit { 
			font-weight: 600;
			font-size: 20px;
			color: #333333;
		}
		.success-icon {
			width: 64px;
			height: 108px;
		}
		.submit-btn {
			height: 44px;
			line-height: 44px;
			background: #CF2427;
			border-radius: 22px;
			font-weight: 600;
			font-size: 16px;
			color: #FFFFFF;
			text-align: center;
			margin-top: 30px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/view/moblieHome.vue